import cn from "classnames";
import React, { useState } from "react";
import { setLastCorrectOdometerValue } from "sources/books/trackers";

export default function EditOdometerValue({ data, onSave, back }) {
    const [comment, setComment] = useState(data.comment || "");
    const [loading, setLoading] = useState(false);

    const handleCommentChange = (e) => setComment(e.target.value);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const result = await setLastCorrectOdometerValue({ ...data, isCorrect: true, comment });
        setLoading(false);
        if (result) {
            onSave();
            back();
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <label className="form-label mb-1" htmlFor="odometer-comment-input">
                Комментарий
            </label>
            <input
                id="odometer-comment-input"
                type="text"
                className="form-control form-control-sm mb-3"
                value={comment}
                onChange={handleCommentChange}
                disabled={loading}
            />
            <button type="submit" className={cn("btn btn-sm btn-brand", { disabled: loading })} disabled={loading}>
                Сохранить
            </button>
        </form>
    );
}
